<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-[50vw] max-w-full lg:w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ isNew ? ( 'newCron' | translate ) : ( 'editCron' | translate ) }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="name" class="text-left font-semibold">Worker</label>
      <p-select id="name"
                [options]="typeOptions"
                optionLabel="description"
                [(ngModel)]="selectedType"
                class="col-span-2 text-left"
                appendTo="body"
                [disabled]="!isNew">

        <!-- Template per l'elemento correntemente selezionato -->
        <ng-template #selectedItem let-selectedOption>
          @if (selectedOption) {
          <span>{{ selectedOption.description | translate }}</span>
          }
        </ng-template>

        <!-- Template per la lista degli elementi nel menu a tendina -->
        <ng-template #item let-option>
          @if (option) {
          <span>{{ option?.description | translate }}</span>
          }
        </ng-template>
      </p-select>
    </div>

    <p-tabs [(value)]="tabsId">
      <p-tablist>
        <p-tab value="0">{{ 'general' | translate }}</p-tab>
        <p-tab value="1">{{ 'organizations' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="grid grid-cols-3 items-center gap-3 pb-3">
            <label class="text-left font-semibold">{{ 'execution' | translate }}</label>
            <label for="day" class="text-center">{{ titleDays | translate }}</label>
            <label for="time" class="text-center">{{ titleTime | translate }}</label>

            <p-inputnumber class="col-start-2" id="day" [(ngModel)]="work.deltaDays" [showButtons]="true" [min]="0" [max]="14" [step]="1" (onInput)="onDaysInput($event)" />
            <p-datepicker id="time" [(ngModel)]="delta" [timeOnly]="true" />

            <label class="text-left font-semibold">{{ 'last' | translate }} {{ 'execution' | translate }}</label>
            <label class="col-span-2">{{ work.last | statusDate }}</label>

            <label class="text-left font-semibold">{{ 'next' | translate }} {{ 'execution' | translate }}</label>
            <label class="col-span-2">{{ work.next | statusDate }}</label>

          </div>
          <hr />
          <div class="grid grid-cols-3 items-center gap-3 py-3">
            <div class="border-round shadow-1 col-span-3 flex items-center justify-between p-3">
              <div class="flex items-center gap-3">
                <p-toggleswitch [(ngModel)]="work.isEnabled"></p-toggleswitch>
                <span [ngClass]="work.isEnabled ? 'text-green-600 font-semibold': 'text-red-500 font-semibold'">
                  {{ work.isEnabled ? ('active' | translate) : ('deactivated' | translate) }}
                </span>
              </div>
              <i class="pi"
                 [ngClass]="work.isEnabled ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-400'"
                 style="font-size: 1.4rem;"></i>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="grid grid-cols-3 items-center gap-3 py-3">
            <div class="border-round shadow-1 col-span-3 flex items-center justify-between p-3">
              <div class="flex items-center gap-3">
                <p-toggleswitch [(ngModel)]="work.all"></p-toggleswitch>
                <span class="font-semibold">{{ 'allOrgDept' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-3 items-center gap-3">
            <label for="org" class="text-left font-semibold">{{ 'organization' | translate }}</label>
            <p-select id="org" [options]="orgOptions" optionLabel="value" [(ngModel)]="selectedOrg" [disabled]="work.all" (onChange)="onOrgChange($event)" class="col-span-2 text-left" appendTo="body" />

            <label for="depts" class="text-left font-semibold">{{ 'departments' | translate }}</label>
            <p-listbox id="depts" [options]="deptsOptions" optionLabel="value" [(ngModel)]="selectedDepts" [disabled]="work.all" (onChange)="onDeptChange($event)" [multiple]="true" [checkbox]="true" class="col-span-2" appendTo="body" />
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.cancel' | translate"
              [text]="true"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'save' | translate"
              [disabled]="selectedType.typeId === '' && work.organizationId === 0 && !work.all"
              (click)="onSave()" />
  </ng-template>
</p-dialog>
